(() => {
  // The server renders the first batch in stock order. Only fetch later batches
  // when that batch cannot fill the carousel with available products.
  const selector = 'template[data-featured-stock-page]';

  async function completeStockOrder(marker) {
    if (marker.dataset.initialized) return;
    marker.dataset.initialized = 'true';

    const limit = Number(marker.dataset.limit);
    const sectionId = marker.dataset.sectionId;
    const grid = document.getElementById(`Slider-${sectionId}`);
    if (!grid) return;
    const cards = new Map(Array.from(grid.querySelectorAll(':scope > li[data-product-id]'), (card) => [card.dataset.productId, card]));
    const availableCount = () => Array.from(cards.values()).filter((card) => card.dataset.available === 'true').length;
    let nextUrl = marker.dataset.nextUrl;

    if (!limit || !sectionId || !nextUrl || availableCount() >= limit) return;

    grid.setAttribute('aria-busy', 'true');
    const visited = new Set();

    try {
      while (nextUrl && availableCount() < limit && grid.isConnected) {
        const url = new URL(nextUrl, window.location.href);
        if (url.origin !== window.location.origin) throw new Error('Unexpected collection origin.');
        // Preserve the preview theme and locale while using Shopify's page key.
        const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
        url.searchParams.set('section_id', sectionId);
        if (visited.has(url.href)) throw new Error('Repeated collection page.');
        visited.add(url.href);

        const response = await fetch(url.href, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) });
        if (!response.ok) throw new Error(`Request failed with status ${response.status}.`);
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = parsed.getElementById(grid.id);
        const nextMarker = parsed.querySelector(selector);
        if (!nextGrid || !nextMarker || nextMarker.dataset.sectionId !== sectionId) throw new Error('Product section missing.');

        nextGrid.querySelectorAll(':scope > li[data-product-id]').forEach((card) => {
          if (!cards.has(card.dataset.productId)) cards.set(card.dataset.productId, card);
        });
        nextUrl = nextMarker.dataset.nextUrl;
      }

      if (!grid.isConnected) return;
      const allCards = Array.from(cards.values());
      const rankedCards = [
        ...allCards.filter((card) => card.dataset.available === 'true'),
        ...allCards.filter((card) => card.dataset.available !== 'true'),
      ].slice(0, limit);
      const fragment = document.createDocumentFragment();
      rankedCards.forEach((card, index) => {
        card.id = `Slide-${sectionId}-${index + 1}`;
        card.style.setProperty('--animation-order', index + 1);
        card.classList.add('scroll-trigger--cancel');
        card.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'));
        card.querySelectorAll('img').forEach((image) => image.setAttribute('loading', 'lazy'));
        fragment.appendChild(card);
      });
      // Keep a user's keyboard focus on the same product if it remains present.
      const focusedElement = grid.contains(document.activeElement) ? document.activeElement : null;
      grid.replaceChildren(fragment);
      grid.closest('slider-component')?.resetPages();
      if (focusedElement?.isConnected) focusedElement.focus({ preventScroll: true });
    } catch (error) {
      // Keep the complete server-rendered carousel usable if a request fails.
      console.warn('[Featured stock priority]', error);
    } finally {
      grid.removeAttribute('aria-busy');
    }
  }

  function init(root = document) {
    root.querySelectorAll(selector).forEach(completeStockOrder);
  }

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
